import {BotMessageObject, BotMessageSendObject} from "../../types/chat";

export function isBotMessageObject(object: any): object is BotMessageObject {
    return (
        typeof object === "object" &&
        typeof object.type === "string" &&
        typeof object.class === "string" &&
        typeof object.messageId === "string" &&
        typeof object.messageText === "string" &&
        typeof object.speechToText === "boolean" &&
        typeof object.trademark === "string" &&
        typeof object.client === "string" &&
        typeof object.createdAt === "string"
    );
}
export function isBotSendMessageObject(object: any): object is BotMessageSendObject {
    return (
        typeof object === "object" &&
        typeof object.type === "string" &&
        typeof object.class === "string" &&
        typeof object.messageId === "string" &&
        typeof object.sessionId === "string" &&
        typeof object.userChatSessionId === "string" &&
        typeof object.messageText === "string" &&
        typeof object.speechToText === "boolean" &&
        typeof object.trademark === "string" &&
        typeof object.client === "string" &&
        typeof object.subscriberId === "number" &&
        typeof object.createdAt === "string"
    );
}